// This plugin should be used when mounting all entrypoints to ensure global styles are added as a shared
// component without deduplication
import { useGlobalState } from "@/core/composables/global-state";
import { VueDataStateKey } from "@/core/composables/global-state";
// Vue plugin
export default {
    install: async (app) => {
        const globalState = useGlobalState();
        if (globalState.get(VueDataStateKey.GlobalStylesInjected))
            return;
        // app.use() does not await install, so claiming after the import lets every entrypoint inject its own copy.
        globalState.set(VueDataStateKey.GlobalStylesInjected, true);
        // Importing the component is enough to ensure that its style block is injected into the document's head.
        const GlobalSCSSPlugin = await import("@/core/components/GlobalSCSSRules.vue");
        app.component("GlobalSCSSRules", GlobalSCSSPlugin);
    }
};
